import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  defineAsyncComponent,
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
} from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import router from "./router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale("zh-cn");
const locale = ref(zhCN);
const store = useStore();
// import DataCenter from "./views/DataCenter.vue"
const DataCenter = defineAsyncComponent(() => import("./views/DataCenter.vue"));
// export default defineComponent({
//   components:{
//     DataCenter
//   },
//   setup() {

//     return {};
//   },
// });
const timerInval = ref();
const startSubTimer = () => {
  clearInterval(timerInval.value);
  timerInval.value = null;
  timerInval.value = setInterval(() => {
    store.dispatch("getSubOrderWatch");
  }, 2000);
};

const refundTimerInval = ref();
const startRefundTimer = () => {
  clearInterval(refundTimerInval.value);
  refundTimerInval.value = null;
  refundTimerInval.value = setInterval(() => {
    store.dispatch("getRefundOrderWatch");
  }, 2000);
};

onMounted(() => {
  if (!localStorage.getItem("REFUNDNotifNO")) {
    store.dispatch("changeRefundCheckedValue", true);
  }
  if (!localStorage.getItem("NotifNO")) {
    store.dispatch("changeSubCheckedValue", true);
  }
  startSubTimer();
  startRefundTimer();
});
onBeforeUnmount(() => {
  stopAllTimer();
});
const stopAllTimer = () => {
  clearInterval(timerInval.value);
  timerInval.value = null;
  clearInterval(refundTimerInval.value);
  refundTimerInval.value = null;
};
router.beforeEach((to, from, next) => {
  //退出到登录的时候停止监听
  if (to.path == "/login") {
    stopAllTimer();
  } else {
    startSubTimer();
    startRefundTimer();
  }
  next();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: locale.value }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})